import React from 'react';
import { Grid, Link, Typography, Container } from '@mui/material';
// import logoIcon from '../../../assets/images/logos/logoIcon.svg';
import Image from "../../../utils/Image";

const Footer = () => {
  return (
    <Container maxWidth="lg">
      <Grid container spacing={3} justifyContent="center" mt={4}>
        <Grid item xs={12} sm={5} lg={4} textAlign="center">
          {/* <Image src={logoIcon} alt="icon" width="32" height="32" /> */}
          <Image src={'https://familygeeks.com/members/wp-content/uploads/2023/08/logoIcon.svg'} alt="icon" width="32" height="32" />
          <Typography fontSize="16" color="textSecondary" mt={1} mb={4}>
            All rights reserved by Vulcano. Designed & Developed by
            <Link target="_blank" href="https://wantdigitalagency.com/">
              <Typography color="textSecondary" component="span" display="inline">
                {' '}
                {/* AdminMart */}
                GeekLabs
              </Typography>{' '}
            </Link>
            .
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Footer;
